import dayjs from "dayjs";
import React,{ useEffect, useState } from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import { getAllLeaveApplicationByUser } from "../../../api/leaveApplicationApi";
import { getOU } from "../../../api/ouApi";
import { getDepartment } from "../../../api/deptApi";
import { getESSEmployee } from "../../../api/employeeApi";
import { getAllLeaveTypes } from "../../../api/leaveTypeApi";
import LeaveAdminForm from "../../forms/AdminPortal/LeaveAdminForm";
import { useLocation } from "react-router-dom";

export default function LeaveAdminPage({ history}) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [allLeaveDS, setAllLeaveDS] = useState([]);
    const [filteredLeaveDS, setFilteredLeaveDS] = useState([]);
    const [form] = Form.useForm();
    const location = useLocation();   //remain filter values when close input form
    const [currentYear, setCurrentYear] = useState(
      location.state ? location.state.filterYear : dayjs().year()
    );
    const [currentMonth, setCurrentMonth] = useState(
      location.state ? location.state.filterMonth : dayjs().month() + 1
    );
    const [allLeaveTypes, setAllLeaveTypes] = useState([]);
    const [allOUs, setAllOUs] = useState([]);
    const [allDepartments, setAllDepartments] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [initialUsers, setInitialUsers] = useState([]);
    const [leaveTypeKey, setLeaveTypeKey] = useState(
      location.state ? location.state.filterLeaveTypeKey : 0
    );
    const [ouKey, setOUKey] = useState(
      location.state ? location.state.filterOUKey : 0
    );
    const [deptKey, setDeptKey] = useState(
      location.state ? location.state.filterDeptKey : 0
    );
    const [userKey, setUserKey] = useState(
      location.state ? location.state.filterUserKey : 0
    );
    const [pagination, setPagination] = useState(
      {
        current: 1,
        minIndex: 0,
        maxIndex: 100,
        pageSize: 100,
      });

    useEffect(getLeaves, []);

    function getLeaves() {
      let promises = [
        getLeaveDataSource(currentYear, currentMonth),
        getAllLeaveTypes(),
        getOU(),
        getDepartment(),
        getESSEmployee(),
      ];

      Promise.all(promises).then((values) => {
        // reset pagination
        resetPagination();

        setAllLeaveTypes(values[1] ? values[1].filter((x) => x.Active) : []);
        setAllOUs(values[2] ? values[2].filter((x) => x.Active) : []);
        setAllDepartments(values[3] ? values[3].filter((x) => x.Active) : []);
        setAllUsers(values[4] ? values[4] : []);
        setInitialUsers(values[4] ? values[4] : []);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setAllLeaveDS([]);
        setFilteredLeaveDS([]);
        setAllLeaveTypes([]);
        setAllOUs([]);
        setAllDepartments([]);
        setAllUsers([]);
        setInitialUsers([]);
        showErrorMessage(
          t('general.fail_to_load_record') + 
            error.response.data.error_description
        );
      });
    }

    function getLeaveDataSource(currentYear, currentMonth) {
      setIsLoading(true);
      
      getAllLeaveApplicationByUser(currentYear, currentMonth, true)
        .then((result) => {
          setAllLeaveDS(result);
          setFilteredLeaveDS(
            result.filter(
              (x) => 
                (ouKey === 0 || x.OUKey === ouKey) &&
                (deptKey === 0 || x.DeptKey === deptKey) &&
                (userKey === 0 || x.UserKey === userKey) && 
                (leaveTypeKey === 0 || x.LTKey === leaveTypeKey)
              )
          );

          setIsLoading(false);
        }).catch((error) => {
          setIsLoading(false);
          setAllLeaveDS([]);
          setFilteredLeaveDS([]);
          showErrorMessage(
            t('general.fail_to_load_record') + 
              error.response.data.error_description
          );
        });
    }

    function onViewLeave(leaveTransKey) {
      history("/home/leaveapplication/leavetrans/" + leaveTransKey, 
      { state: { 
        fromAdmin: true,
        filterOUKey: ouKey,
        filterDeptKey: deptKey,
        filterUserKey: userKey,
        filterLeaveTypeKey: leaveTypeKey,
        filterYear: currentYear,
        filterMonth: currentMonth,
       }});
    }

    function getValidAttachments(attachments) {
      return getSignedAttachmentUrl(attachments);
    }

    function filterRecord(ouKey, deptKey, userKey, leaveTypeKey) {
      setOUKey(ouKey);
      setDeptKey(deptKey);
      setUserKey(userKey);
      setLeaveTypeKey(leaveTypeKey);
      setFilteredLeaveDS(
        allLeaveDS.filter(
          (x) => 
            (ouKey === 0 || x.OUKey === ouKey) &&
            (deptKey === 0 || x.DeptKey === deptKey) &&
            (userKey === 0 || x.UserKey === userKey) && 
            (leaveTypeKey === 0 || x.LTKey === leaveTypeKey)
          )
      );
    }

    function showErrorMessage(message) {
      toast.error(message);
    }

    function resetPagination() {
      setPagination({
        current: 1,
        minIndex: 0,
        maxIndex: 100,
        pageSize: 100,
      });
    }

    return (
      <LeaveAdminForm 
        isLoading={isLoading}
        leaveDS={filteredLeaveDS}
        getLeaveDataSource={getLeaveDataSource}
        form={form}
        onViewLeave={onViewLeave}
        onAttachmentClicked={getValidAttachments}
        setCurrentYear={setCurrentYear}
        setCurrentMonth={setCurrentMonth}
        allLeaveTypes={allLeaveTypes}
        allOUs={allOUs}
        allDepartments={allDepartments}
        allUsers={allUsers}
        initialUsers={initialUsers}
        setAllUsers={setAllUsers}
        ouKey={ouKey}
        deptKey={deptKey}
        userKey={userKey}
        leaveTypeKey={leaveTypeKey}
        currentYear={currentYear}
        currentMonth={currentMonth}
        filterRecord={filterRecord}
        pagination={pagination}
        setPagination={setPagination}
        resetPagination={resetPagination}
      />
    );
}

LeaveAdminPage.propTypes = {
  history: PropTypes.func.isRequired,
};